import React from 'react';

interface UnauthorizedOverlayProps {
  reason?: string;
}

function getReasonDisplay(reason?: string): { label: string; instruction: string } {
  if (!reason) return { label: '', instruction: 'Skontaktuj się z Menedżerem organizacji, aby otrzymać link z dostępem do aplikacji.' }
  const lower = reason.toLowerCase()
  if (lower.includes('organizacja nieaktywna'))
    return { label: reason, instruction: 'Organizacja została dezaktywowana. Skontaktuj się z administratorem.' }
  if (lower.includes('subskrypcja wygasła'))
    return { label: reason, instruction: 'Subskrypcja organizacji wygasła. Skontaktuj się z Supervisorem w celu odnowienia.' }
  if (lower.includes('okres próbny'))
    return { label: reason, instruction: 'Okres próbny wygasł. Skontaktuj się z Supervisorem w celu zakupu subskrypcji.' }
  if (lower.includes('konto nieaktywne'))
    return { label: reason, instruction: 'Twoje konto zostało dezaktywowane. Skontaktuj się z Supervisorem organizacji.' }
  if (lower.includes('limit tokenów'))
    return { label: reason, instruction: 'Wyczerpany limit tokenów w organizacji. Skontaktuj się z Supervisorem.' }
  return { label: reason, instruction: 'Skontaktuj się z Menedżerem organizacji, aby rozwiązać problem.' }
}

export const UnauthorizedOverlay: React.FC<UnauthorizedOverlayProps> = ({ reason }) => {
  const display = getReasonDisplay(reason)
  return (
    <div style={{
      position: 'absolute',
      inset: 0,
      zIndex: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      backdropFilter: 'blur(6px)',
      WebkitBackdropFilter: 'blur(6px)',
      background: 'rgba(0,0,0,0.45)',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '360px',
        borderRadius: '33px',
        overflow: 'hidden',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        background: 'linear-gradient(180deg, rgba(153,0,0,0.32) 5%, rgba(255,0,0,0.38) 56%, rgba(153,0,0,0.32) 100%)',
        border: '1px solid rgba(255,80,80,0.18)',
        boxShadow: '0 8px 48px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.08)',
        padding: '32px 28px 36px 28px',
        userSelect: 'none',
        textAlign: 'center',
      }}>

        {/* Etykieta */}
        <div style={{
          color: 'rgba(255,255,255,0.55)',
          fontSize: '11px',
          fontFamily: '"Inter", sans-serif',
          fontWeight: 400,
          letterSpacing: '2.5px',
          textTransform: 'uppercase',
          marginBottom: '20px',
        }}>
          Brak dostępu
        </div>

        {/* Ikona zamkniętej kłódki */}
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
            stroke="rgba(255,120,120,0.85)" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>

        {/* Komunikat główny */}
        <div style={{
          color: 'rgba(255,255,255,0.90)',
          fontSize: '16px',
          fontFamily: '"Inter", sans-serif',
          fontWeight: 400,
          letterSpacing: '0.3px',
          lineHeight: 1.5,
          marginBottom: '14px',
        }}>
          Brak autoryzacji
        </div>

        {/* Powód (granularny) */}
        {display.label && (
          <div style={{
            color: 'rgba(255,180,180,0.85)',
            fontSize: '14px',
            fontFamily: '"Inter", sans-serif',
            fontWeight: 400,
            letterSpacing: '0.2px',
            lineHeight: 1.5,
            marginBottom: '22px',
          }}>
            {display.label}
          </div>
        )}

        {/* Separator */}
        <div style={{
          height: '1px',
          background: 'rgba(255,255,255,0.08)',
          margin: '0 -28px 22px -28px',
        }} />

        {/* Instrukcja */}
        <div style={{
          color: 'rgba(255,255,255,0.55)',
          fontSize: '13px',
          fontFamily: '"Inter", sans-serif',
          fontWeight: 300,
          letterSpacing: '0.3px',
          lineHeight: 1.6,
        }}>
          {display.instruction}
        </div>

      </div>
    </div>
  );
};
